// extracted by mini-css-extract-plugin
module.exports = {"ForumSearch__headline":"qk_a bhu_rh bhu_tu","ForumSearch__img":"qk_b","ForumSearch__searchAdsAndShoppingAds":"qk_c","ForumSearch__results--empty":"qk_e"};